
import request from '@/utils/server'


export function uploadApk(data) {
    return request({
      url: '/files/uploadApk',
      method: 'post',
      data:data
    })
  }
  export function getApkList(query) {
    return request({
      url: '/files/getApkList',
        method: 'get',
      params: query
    })
  }